<div
    class="d-flex align-items-center gap-1 p-0 ps-3 fw-bold cursor-pointer btn btn-link"
    (click)="onUserClick()"
    [ngClass]="{ 'text-danger': !isScheduleAfterNextWorkingDay() }"
>
    <fa-icon [icon]="faTools"></fa-icon>
    <span class="d-none d-lg-block">{{ scheduleDateAndTime() }}</span>
</div>
